import React from 'react'
import EntryButton from './EntryButton'

class StickyButton extends React.Component {
  render() {
    return (
      <div className={`sticky-button ${this.props.show}`}>
        <EntryButton id={this.props.id} />
      </div>
    )
  }
}

export default StickyButton